import { TreoNavigationItem } from '../@treo/components/navigation';

export const DefaultNavigationList: TreoNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    link: '/dashboard',
    icon: 'mat_outline:dashboard',
  },
  {
    id: 'insightsDashboard',
    title: 'Insights',
    type: 'basic',
    link: '/insights',
    icon: 'heroicons_outline:trending-up',
  },
  {
    id: 'analytics',
    title: 'Analytics',
    type: 'basic',
    link: '/analytics',
    icon: 'heroicons_outline:chart-pie',
  },
  {
    id: 'reports',
    title: 'Reports',
    type: 'collapsable',
    icon: 'heroicons_outline:document-report',
    children: [
      {
        id: 'statusReport',
        title: 'Status Report',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/status-report',
      },
      {
        id: 'reportsNetworkLogs',
        title: 'Network Logs',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/network-log-report',
      },
      {
        id: 'reportsNetworkLogStatus',
        title: 'Network Log Status',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/network-log-status-report',
      },
      {
        id: 'reportsShiftLog',
        title: 'Shift Log',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/shift-log-report',
      },
      {
        id: 'misReport',
        title: 'MIS Report v5',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/mis-report',
      },
      {
        id: 'oldMisReport',
        title: 'MIS Report v4',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/mis-old-report',
      },
      {
        id: 'idleLogReport',
        title: 'Idle Log Report',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/idle-log-report',
      },
      {
        id: 'advanceSearch',
        title: 'Advance Report',
        type: 'basic',
        icon: 'feather:activity',
        link: '/reports/advance',
      },
    ],
  },
  {
    id: 'orgMembers',
    title: 'Organization Members',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/canvas',
  },
  {
    id: 'configuration',
    title: 'Configuration',
    type: 'basic',
    icon: 'heroicons_outline:adjustments',
    link: '/configuration',
  },
];

export const InternalNavigationList: TreoNavigationItem[] = [
  /*{
    id: 'internalDashboard',
    title: 'Dashboard',
    type: 'basic',
    link: '/dashboard-admin',
    icon: 'apps'
  },*/
  {
    id: 'configuration',
    title: 'Configurations',
    type: 'basic',
    icon: 'settings',
    link: '/configuration',
  },
  {
    id: 'appRoles',
    title: 'Application Roles',
    type: 'basic',
    icon: 'note',
    link: '/internal/roles',
  },
  {
    id: 'permissions',
    title: 'Permissions',
    type: 'basic',
    icon: 'note',
    link: '/internal/permissions',
  },
  {
    id: 'manageOrgs',
    title: 'Organization',
    type: 'basic',
    icon: 'note',
    link: '/internal/orgs',
  },
];
